module.exports = __webpack_public_path__ + "static/img/power-plant.7b8cfb96.png";